import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const StarIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue838'}</MuiIcon>
    );
}
